import React from 'react';
import DataDrivenGuidePage from '../../components/guides/DataDrivenGuidePage';

const CrcCalculatorGuidePage = () => <DataDrivenGuidePage slug="guide-crc-calculator" />;

export default CrcCalculatorGuidePage;
